"use client";

import { Modal, ModalBody, ModalContent } from "@nextui-org/react";
import { useRouter } from "next/navigation";
import { create } from "zustand";
import { useEffect } from "react";
import { useUserInfo } from "../hooks";
import PaymentV2 from "@/03-presenters/widgets/PaymentV2";
type isOpenType = boolean | {
  type: "UNAUTHORIZED_ERROR" | "OUT_OF_LIMIT_ERROR" | "SEA_BAY_INSUFFICIENT";
  open: boolean;
  defaultVersion?: string;
  showSeaBayTips?: boolean;
  onOpenLogin?: (isOpen: boolean) => void;
};
export const paymentModalStore = create<{
  defaultVersion?: string;
  isOpen: isOpenType;
  setIsOpen: (isOpen: isOpenType) => void;
  setDefaultVersion: (defaultVersion?: string) => void;
}>(set => ({
  isOpen: false,
  defaultVersion: undefined,
  setIsOpen: (isOpen: isOpenType) => {
    if (typeof isOpen === "boolean") {
      set({
        isOpen
      });
    } else {
      set({
        isOpen,
        defaultVersion: isOpen.defaultVersion
      });
    }
  },
  setDefaultVersion: defaultVersion => set({
    defaultVersion
  })
}));
export default function PaymentModal() {
  const payModalIsOpen = paymentModalStore(state => state.isOpen);
  const payModalOnOpenChange = paymentModalStore(state => state.setIsOpen);
  const defaultVersion = paymentModalStore(state => state.defaultVersion);
  const setDefaultVersion = paymentModalStore(state => state.setDefaultVersion);
  const isOpen = typeof payModalIsOpen === "boolean" ? payModalIsOpen : payModalIsOpen.open;
  const type = typeof payModalIsOpen === "boolean" ? undefined : payModalIsOpen.type;
  const showSeaBayTips = typeof payModalIsOpen === "boolean" ? undefined : payModalIsOpen.showSeaBayTips;
  const onOpenLogin = typeof payModalIsOpen === "boolean" ? undefined : payModalIsOpen.onOpenLogin;
  const router = useRouter();
  const {
    isLogin,
    user,
    userAuthInfo
  } = useUserInfo();
  useEffect(() => {
    return () => {
      payModalOnOpenChange(false);
    };
  }, []);
  useEffect(() => {
    if (!isLogin && isOpen) {
      if (onOpenLogin) {
        onOpenLogin(true);
      } else {
        router.replace("/login");
      }
    }
  }, [isLogin, router, isOpen, payModalOnOpenChange, onOpenLogin]);
  useEffect(() => {
    if (!isOpen) {
      setDefaultVersion();
    }
  }, [isOpen, setDefaultVersion]);
  if (!isLogin) {
    return null;
  }
  return <Modal size="5xl" isOpen={isOpen} onOpenChange={payModalOnOpenChange} isDismissable={false} closeButton={<></>} data-sentry-element="Modal" data-sentry-component="PaymentModal" data-sentry-source-file="payment-modal.tsx">
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="payment-modal.tsx">
        <ModalBody className="relative gap-0 p-0" data-sentry-element="ModalBody" data-sentry-source-file="payment-modal.tsx">
          <PaymentV2 defaultVersion={defaultVersion} type={type} showSeaBayTips={!!showSeaBayTips} onClose={() => {
          payModalOnOpenChange(false);
        }} data-sentry-element="PaymentV2" data-sentry-source-file="payment-modal.tsx" />
        </ModalBody>
      </ModalContent>
    </Modal>;
}